// styleTags/index.tsx にあった既存のタグ語彙を共通定数化したもの。
// フィルタバーのタグ絞り込み・カードのタグ表示・タグピッカー・アップロードエディタが
// すべてここを唯一の情報源として参照する。文言は既存実装から一字一句そのまま引き継ぐ。

export type TagCategory = { label: string; values: string[] };

export const TAG_CATEGORIES: TagCategory[] = [
  {
    label: 'スタイル関連',
    values: [
      'ストリート',
      'クラシック',
      'モード',
      'フェミニン',
      'グランジ',
      'アンニュイ',
      'ロック',
      'クリエイティブ',
    ],
  },
  {
    label: 'カット関連',
    values: [
      'セニングカット',
      'シャギーカット',
      'スライドカット',
      'ドライカット',
      'レザーカット',
      'レイヤーカット',
      'ウルフカット',
      'ボブカット',
      'チョップカット',
      'ブラントカット',
      'グラデーションカット',
    ],
  },
  {
    label: 'パーマ関連',
    values: [
      'コールドパーマ',
      '水パーマ',
      'ピンパーマ',
      'ストレートパーマ',
      'ツイストパーマ',
      'スパイラルパーマ',
      'ツイストスパイラルパーマ',
      'ニュアンスパーマ',
      'カルマパーマ',
      'ワンカールパーマ',
      'デジタルパーマ',
      'ホットパーマ',
      'エアウエーブパーマ',
      'クリープパーマ',
    ],
  },
  {
    label: 'カラー関連',
    values: [
      'グラデーションカラー',
      'ハイライトカラー',
      'ローライトカラー',
      'イヤリングカラー',
      'ヴェールカラー',
      'イルミナカラー',
      'ハイトーンカラー',
    ],
  },
  {
    label: '縮毛矯正関連',
    values: [
      '酸性縮毛',
      'アルカリ性縮毛',
      '低温縮毛',
    ],
  },
];

// 性別スタイル。post_tagsと同じ配列・同じ上限予算を共有する(既存挙動を踏襲)。
export const GENDER_VALUES = ['メンズ', 'レディース'];

// 「その他のタグ」として選択できる上限数(既存のstyleTags実装のpushStyleロジックを踏襲)。
export const MAX_TAGS = 5;

export const ALL_TAG_VALUES: string[] = TAG_CATEGORIES.flatMap((c) => c.values);
